import React from "react";
import Adfectus_logo from "../assets/Adfectus_logo.png";

function Settings() {

    return (

        <div className="MainLogin">

            <img src={Adfectus_logo} className="Logo" alt="Logo" />

        </div>

    );
}
export default Settings;